import HowCanWeHelpStep from '../../steps/HowCanWeHelpStep';
import RedirectingStep from '../../steps/RedirectingStep';
import { OnboardingNodeType, OnboardingStepType } from '../../steps/types';
import { OnboardingNode } from '../../types';

export const TREATMENT_PREFERENCE_NODE: OnboardingNode = {
  index: 0,
  key: OnboardingNodeType.TREATMENT_PREFERENCE,
  options: { countsTowardProgressBar: false, optional: true },
  elements: [
    {
      condition: [
        {
          step: OnboardingNodeType.PRIMARY_SUBSTANCE,
          hasOneFieldOption: 'treatableTreatmentPreferences'
        }
      ],
      uid: OnboardingStepType.TREATMENT_PREFERENCE,
      component: (
        <RedirectingStep
          redirectToNodeType={OnboardingNodeType.RECOVERY_GOAL}
          uid={OnboardingStepType.TREATMENT_PREFERENCE}
          nodeType={OnboardingNodeType.TREATMENT_PREFERENCE}
          displayName=""
          actionButtonText="Next"
        />
      )
    },
    {
      condition: [
        {
          step: OnboardingNodeType.TREATMENT_PREFERENCE,
          hasFieldOptions: 'treatableTreatmentPreferences'
        }
      ],
      uid: OnboardingStepType.TREATMENT_PREFERENCE,
      component: (
        <HowCanWeHelpStep
          uid={OnboardingStepType.TREATMENT_PREFERENCE}
          nodeType={OnboardingNodeType.TREATMENT_PREFERENCE}
          displayName="Your Treatment Needs & Goals"
          actionButtonText="Next"
          showAllContent={false}
        />
      )
    },

    {
      uid: OnboardingStepType.TREATMENT_PREFERENCE,
      component: (
        <RedirectingStep
          redirectToNodeType={OnboardingNodeType.RECOVERY_GOAL}
          uid={OnboardingStepType.TREATMENT_PREFERENCE}
          nodeType={OnboardingNodeType.TREATMENT_PREFERENCE}
          displayName=""
          actionButtonText="Next"
        />
      )
    }
  ]
};
